export const CodeValue = {
  // 关系
  Family: [
    { code: 'father', value: '爸爸', imgcode: 3 },
    { code: 'mother', value: '妈妈', imgcode: 4 },
    { code: 'grandfather', value: '爷爷', imgcode: 1 },
    { code: 'grandmother', value: '奶奶', imgcode: 2 },
    { code: 'other', value: '其他', imgcode: 7 }
  ],
  // 学校
  School: [],
  // 班级
  Class: []
}

/**
 * 根据type+code拿值
 */
export const FilterCode = (type, code, field = 'value') => {
  const CodeItem = CodeValue[type]
  if (CodeItem) {
    const FilterItem = CodeItem.filter(({ code: _code }) => _code === code || _code.toString() === code)
    if (FilterItem.length > 0) {
      let value = FilterItem[0][field]
      return value
    } else {
      return null
    }
  } else {
    return null
  }
}
/**
 * 根据type+value拿值
 */
export const FilterValue = (type, value, field = 'code') => {
  const CodeItem = CodeValue[type]
  if (CodeItem) {
    const FilterItem = CodeItem.filter(({ value: _value }) => _value === value || _value.toString() === value)
    if (FilterItem.length > 0) {
      let code = FilterItem[0][field]
      return code
    } else {
      return null
    }
  } else {
    return null
  }
}

export default {
  install: Vue => {
    Vue.prototype.$CodeValue = CodeValue
    Vue.prototype.$FilterCode = FilterCode
    Vue.prototype.$FilterValue = FilterValue
    // 注册过滤器
    for (let codeName in CodeValue) {
      Vue.filter(codeName, code => {
        return FilterCode(codeName, code)
      })
    }
  }
}
